export default {
      id: "file_management-usage",
      viewBox: "0 0 268.58 313.45",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#file_management-usage",
      toString: function () {
        return this.url;
      }
    }